import { jsx, jsxs } from "react/jsx-runtime";
import React__default from "react";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import Row from "../Grid/Row.js";
import './CarTile.css';import '../Grid/Grid.css';/* empty css                */
import Icon from "../Icon/Icon.js";
import Price from "../Price/Price.js";
import Tooltip from "../Tooltip/Tooltip.js";
import Typography from "../Typography/Typography.js";
/* empty css             */
const CarTilePrice = ({
  price,
  benefits,
  additions,
  hasTouchListener,
  className
}) => {
  const hiddenBenefits = !benefits || benefits.hidden;
  return /* @__PURE__ */ jsx(Row, { className: classnames("perxis-auto-car-tile-price", className), wrap: false, gutter: 8, children: /* @__PURE__ */ jsxs(Col, { flex: "none", children: [
    /* @__PURE__ */ jsx(
      Price,
      {
        value: price.currentValue,
        oldValue: price.oldValue,
        oldValuePosition: price.oldValuePosition,
        className: classnames("perxis-auto-car-tile-price__price"),
        extra: !hiddenBenefits && /* @__PURE__ */ jsx(
          Tooltip,
          {
            showCloseButton: true,
            destroyTooltipOnHide: true,
            hasTouchListener,
            trigger: hasTouchListener ? ["hover"] : ["click", "hover"],
            placement: "top",
            title: benefits == null ? void 0 : benefits.tooltipTitle,
            content: benefits == null ? void 0 : benefits.tooltipContent,
            className: classnames("perxis-auto-car-tile-price__benefits"),
            children: /* @__PURE__ */ jsx(
              Typography.Text,
              {
                level: "small",
                color: "darkest",
                className: classnames("perxis-auto-car-tile-price__benefits-icon"),
                children: /* @__PURE__ */ jsx(Icon, { name: "question" })
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(Typography.Text, { children: price.label }),
    additions == null ? void 0 : additions.map(({ children, ...typographyProps }, index) => {
      const isLink = "href" in typographyProps;
      const resolvedIndex = `${index}-link:${isLink}`;
      const TypographyComponent = isLink ? Typography.Link : Typography.Text;
      return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsx(TypographyComponent, { ...typographyProps, children }),
        " "
      ] }, resolvedIndex);
    })
  ] }) });
};
export {
  CarTilePrice as default
};
//# sourceMappingURL=CarTilePrice.js.map
